// extracted by mini-css-extract-plugin
module.exports = {"icon":"IpDialog_icon__n_xOG"};